import { createContext, useState, useEffect } from "react";
import uslogo from '../assets/img/Ellipse 1840.png';
import frlogo from '../assets/img/Ellipse 1841.png';

export const LanguageContext = createContext();

const LANGUAGES = {
    en: { name: "English", icon: uslogo, id: 1 },
    fr: { name: "French", icon: frlogo, id: 2 }
};

export const LanguageProvider = ({ children }) => {


    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        const saved = localStorage.getItem("lang");
        return saved ? JSON.parse(saved) : LANGUAGES.en;
    });


    useEffect(() => {
        localStorage.setItem("lang", JSON.stringify(selectedLanguage));
    }, [selectedLanguage]);

    const handleSelect = (lang) => {
        setSelectedLanguage(lang);
    };

    return (
        <LanguageContext.Provider value={{ selectedLanguage, handleSelect }}>
            {children}
        </LanguageContext.Provider>
    );
};